import OfficeEditorCreateTablePopup from './OfficeEditorCreateTablePopup';

export default OfficeEditorCreateTablePopup;
